// import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import * as html2pdf from 'html2pdf.js';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
// import { HttpErrorResponse } from '@angular/common/http';
import { toWords } from 'number-to-words';

@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss']
})
export class PaymentReceiptComponent implements OnInit {
  @ViewChild('contentToConvert') contentToConvert!: ElementRef;
  src;
  payHistory: FormGroup;
  payHistoryData: any;
  addmissionData: any;
  clgName: any;
  CoName: any;
  SnNo: any;
  FeeTable: any;
  personaldetails: any;
  TotalPaidAmountInWords: any;
  formattedPrn: any;
  constructor(private fb: FormBuilder, public umsService: UmsService,
    public dialogRef1: MatDialogRef<PaymentReceiptComponent>,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  // listOfFee: any;
  tempCo
  StudentPersonalId
  InstuName
  currentDate
  FirstName: string
  MiddleName: string
  LastName: string
  Number: number
  Email: string
  StudentId
  feeMode
  payModeee
  TransactionNo
  mobileNo
  stuDOB
  DateOfBirth
  MotherName
  FatherName
  FullName
  TotalPaidAmount
  showDownloadButton = true;
  generatingPDF = false;
  downloadingPDF: boolean = true;
  Currency
  reciptNumber
  RgNo
  // payHistoryData: any;
  ngOnInit(): void {
    this.getSecretData();
    this.getUserData(sessionStorage.getItem('StudentRGID'))
    this.prepopulationOfAddmission();
    this.currentDate = new Date();
    this.tempCo = sessionStorage.getItem('TemplateCode');
    this.StudentPersonalId =  sessionStorage.getItem('StuId')?sessionStorage.getItem('StuId'):sessionStorage.getItem("StudentPersonalId");
    this.tempCo = sessionStorage.getItem('TemplateCode');
    this.StudentId =  sessionStorage.getItem('StuId');
    this.feeMode = sessionStorage.getItem('FeeMode');
    sessionStorage.getItem('StudentRGID');    
     if(this.data.FeeType == 'PC' || this.data.FeeType == 'OPC' || this.data.FeeType == 'MC' || this.data.FeeType == 'RC'){
      this.DateOfBirth = false;
      this.clgName = this.data.CgName
    }
    else{
      this.DateOfBirth = true
    }
  }

  getData() {
    this.spinner.show();
    const payload = {};
    payload['TemplateCode'] = this.tempCo;
    payload['FeeType'] = ''
    // this.disablePaid = true;
    this.umsService.getFeeTemplet(payload).subscribe((res) => {
      this.spinner.hide()
      let data = res.data[0];
      this.Currency = res.data[0].Currency
      if (res.status) {
        this.FeeTable = res.data;
      } else {
        // this.umsService.openSnackbar(res.message);
      }
    });
  }


  downloadAsPDF() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const filename = `PaymentReceipt_${formattedDate}.pdf`;

    const options = {
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    const element = this.contentToConvert.nativeElement;
    const buttons = element.querySelectorAll('button');
    buttons.forEach(button => {
        button.style.display = 'none';
    });

    html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        // Restore the visibility of the buttons after PDF generation is complete
        buttons.forEach(button => {
            button.style.display = '';
        });
    });
  }

 
  // getFeeTempData2(item, StuId, CoCode, CgCode) {
  //   const payload = {};
  //   payload['SessionId'] = parseInt(sessionStorage.getItem('session')),
  //   payload['CoCode'] = CoCode;
  //   payload['CgCode'] = CgCode;
  //   payload['StuId'] = this.StudentId;
  //   payload['FeeType'] = 'EF';
  //   this.umsService.fetchFeeTemp(payload).subscribe(res => {
  //     if (res.status) {
  //        this.ExamCurrency = res.data[0].Currency
  //       sessionStorage.setItem('ExamCurrency',this.ExamCurrency)
  //     } else {
       
  //     }
  //   });
  // }

  // getFeeTempData(item, StuId, CoCode, CgCode) {
  //   const payload = {};
  //   payload['SessionId'] = parseInt(sessionStorage.getItem('session')),
  //     payload['CoCode'] = CoCode;
  //   payload['CgCode'] = CgCode;
  //   payload['StuId'] = this.StudentId;
  //   payload['FeeType'] = 'AF';
  //   this.umsService.fetchFeeTemp(payload).subscribe(res => {
  //     if (res.status) {
  //       this.Currency = res.data[0].Currency
  //       sessionStorage.setItem('Currency',this.Currency)
  //     } else {
  //     }
  //   });
  // }

  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.SnNo = res.projectPharam['SnNo']
      this.getHistory(res.projectPharam['SnNo']);
      this.InstuName = res.projectPharam['InstituteName']
      this.getData();
    })
  }
  getHistory(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['FeeTemplateCode'] = this.tempCo;
    payload['StuId'] = this.data.StuId ? this.data.StuId : this.StudentPersonalId;
    payload['FeeHistory'] = 1;
    payload['SnNo'] =this.data.Session ? this.data.Session : this.data.SnNo;
    payload['FeeType']=this.data.FeeType;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.payHistoryData = res.data;
      this.payModeee = res.data[0].card_type;
      this.reciptNumber = res.data[0].PaymentResponseID;
      this.TransactionNo = res.data[0].txnid;
      if (res.data[0].FeeType == "EF") {
        // this.Currency =  sessionStorage.getItem('ExamCurrency')
      }
      else {
        // this.Currency = sessionStorage.getItem('Currency')
      }

      this.TotalPaidAmount = res.data[0].TotalPaidAmount
      this.convert(this.TotalPaidAmount)
    })

  }
  convert(number){
    this.TotalPaidAmountInWords = toWords(number);
  }

  getUserData(id) {
    this.FirstName = ''
    this.MiddleName = ''
    this.LastName = ''
    this.Number = 0
    this.Email = ''
    // this.umsService.getUserData(id).subscribe((res) => {
    //   this.FirstName = res.data[0][0]['StuFirstName']
    //   this.MiddleName = res.data[0][0]['StuMidName']
    //   this.LastName = res.data[0][0]['StuLastName']
    //   this.Number = parseInt(res.data[0][0]['StuMobNumber'])
    //   this.Email = res.data[0][0]['StuEmailId']
    // });
  }
  close() {
    this.dialogRef1.close();
  }


  prepopulationOfAddmission() {
    // this.spinner.show();
    this.StudentPersonalId = sessionStorage.getItem("StudentPersonalId");
    let payload = {};
    payload['StuId'] =  this.data.StuId ? this.data.StuId : this.StudentPersonalId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.addmissionData = res.data[0];
        this.getclg(res.data[0]);
        this.getCourse(res.data[0])
      }
    })

    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.personaldetails = res.data[0];
      
        this.RgNo=res.data[0]['StuRgNo']
        this.formattedPrn = res.data[0]['StuRgNoPrfx']
         if(this.data.FeeType == 'PC' || this.data.FeeType == 'OPC' || this.data.FeeType == 'MC' || this.data.FeeType == 'RC'){
        this.FirstName = this.data.StuName || res.data[0]['StudentFullName'];
       this.MotherName = this.data.MotherName || res.data[0]['StuMothNameEng'];
       this.mobileNo = this.data.Mobile  || res.data[0]['StuNumber'] || '';
       this.FatherName = this.data.FatherName || res.data[0]['StuMidNameEng'];
      }
      else
        {
        this.FirstName = res.data[0]['StuFirstNameEng']
        this.MiddleName = res.data[0]['StuMiddleName']
       this.LastName = res.data[0]['StuLastNameEng']
       this.MotherName = res.data[0]['StuMothNameEng']
       this.mobileNo = res.data[0]['StuNumber']
       this.stuDOB = res.data[0]['StuBirthDate']
       this.FatherName = res.data[0]['StuMidNameEng']
       this.FullName = res.data[0]['StudentFullName']
      }
      }
      else{
        this.FirstName = this.data.StuName
       this.MotherName = this.data.MotherName
       this.mobileNo = this.data.Mobile
       this.FatherName = this.data.FatherName
      }      
    });
    
  }

  getclg(data) {
    let payload = {};
    payload['CgCode'] = data.StuCgId
    this.umsService.getCollege(payload).subscribe((res) => {
      this.clgName = res.data[0].CgName

    })

  }


  getCourse(data) {
    let payload = {};
    payload['CoCode'] = data.StuCoId
    this.umsService.fetchCourseType(payload).subscribe((res) => {
      this.CoName = res.data[0].CoName

    })

  }


  generateSingleFiveDigitReceiptNumber(): string {
    const randomNumber = Math.floor(Math.random() * 100000); // Generate random number between 0 and 99999
    const formattedNumber = randomNumber.toString().padStart(5, '0'); // Ensure it's formatted to have 5 digits with leading zeros
    return formattedNumber;
  }

}
